<template>
  <div id="app">
    <Router-view />
  </div>
</template>
<script>

export default {
  created() {
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });
    // 打包环境下
    if (process.env.NODE_ENV !== "development") {
      document.onkeydown = () => {
        //禁用F12
        if (window.event && window.event.keyCode == 123) {
          return false;
          //禁用ctrl+shift+i,
        } else if (
          window.event.ctrlKey &&
          window.event.shiftKey &&
          window.event.keyCode == 73
        ) {
          return false;
          //屏蔽Shift+F10
        } else if (window.event.shiftKey && window.event.keyCode == 121) {
          return false;
        }
      };
    }
  },
};
</script>
<style lang="less">
#app {
  width: 100vw;
  height: 100vh;
  min-width: 1600px;
  min-height: 800px;
  overflow: auto;
}
</style>
